// External modules
import { Product }             from '../models/product';
import { Calculation }         from '../../pages/calculator-results/calculation.provider';
import { FlushingCalculation } from '../../pages/calculator-results/calculation.provider';
import { VacuumCalculation }   from '../../pages/calculator-results/calculation.provider';
import { ArrayTyper }          from '@caliatys/array-typer';
import { TranslateService }    from '@ngx-translate/core';

export class Cart
{
  public items : CartItem[] = [];
  constructor(obj : any = null)
  {
    if (obj == null)
      return;

    this.items = ArrayTyper.asArray(CartItem, obj.items);
  }

  public get groups() : string[]
  {
    return Array.from(new Set(this.items.map(i => i.group)));
  }

  public products(group : string) : CartItem[]
  {
    return this.items.filter(itm => itm.group === group && itm.item instanceof Product);
  }

  public calculations(group : string) : CartItem[]
  {
    return this.items.filter(itm => itm.group === group && itm.item instanceof Calculation);
  }

  public mailBody(translate : TranslateService, group : string = null) : string
  {
    let body = ""; //translate.instant("MAPAPP_CART_HEADER");
    let groupsUsed = group ? this.groups.filter(gr => gr === group) : this.groups;
    for (let group of groupsUsed)
    {
      body += `<b>${ translate.instant('Name') } : </b>${group} <br /><br />`;
      if (this.products(group).length !== 0)
      {
        // body += translate.instant("MAPAPP_CART_PRODUCT");
        for (let item of this.products(group))
        {
          let date = new Date(item.timestamp).toLocaleDateString(translate.currentLang)
          let product = <Product> item.item;
          body +=
`
<span>${ translate.instant('DATE') } : ${ date }</span><br />
<table style="width: 100%;background-color: #f3f3f3;">
<thead>
  <tr>
    <th colspan="2" style="background-color: #1c4587;color: white;padding: 10px 0;">
      ${product.Name}
    </th>
  </tr>
</thead>
<tbody>
  <tr>
    <td>${ translate.instant('RECOMMENDED_ALIGAL') }</td>
    <td>${ product.ALIGAL }</td>
  </tr>
  <tr>
    <td>${ translate.instant('WITHOUTMAP') }</td>
    <td>${ product.NoMap }</td>
  </tr>
  <tr>
    <td>${ translate.instant('WITHMAP') }</td>
    <td>${ product.WithMap }</td>
  </tr>
  <tr>
    <td>${ translate.instant('STORETEMP') }</td>
    <td>${ product.Temperature }</td>
  </tr>
  <tr>
    <td>${ translate.instant('LIMITFACTORS') }</td>
    <td>${ product.LimitingFactors }</td>
  </tr>
  <tr>
    <td>${ translate.instant('OXYLEVEL') }</td>
    <td>${ product.OxygenLevel }</td>
  </tr>
  <tr>
    <td>${ translate.instant('TYPEOFFILM') }</td>
    <td>${ product.TypeOfFilm }</td>
  </tr>
  <tr>
    <td>${ translate.instant('COUNTRY') }</td>
    <td>${ product.Country }</td>
  </tr>
</tbody>
</table>`;
          body += '<br />';
        }
      }
      if (this.calculations(group).length !== 0)
      {
        // body += translate.instant("MAPAPP_CART_CALCULATION");
        for (let item of this.calculations(group))
        {
          let date = new Date(item.timestamp).toLocaleDateString(translate.currentLang)
          let calculation = <Calculation> item.item;
          if (calculation instanceof FlushingCalculation)
          {
            let flushing = <FlushingCalculation> calculation;
            body +=
`<span>${ translate.instant('DATE') } : ${ date }</span><br />
<table style="width: 100%;background-color: #f3f3f3;">
<thead>
  <tr>
    <th colspan="2" style="background-color: #1c4587;color: white;padding: 10px 0;">
      ${ flushing.name }
    </th>
  </tr>
</thead>
<thead>
  <tr>
    <th colspan="2" style="background-color: #3c78d8;color: white;padding: 5px 0;">
      ${ translate.instant('CALC_PARAMETERS') }
    </th>
  <tr>
</thead>
<tbody>
<tr>
  <td>${ translate.instant('BAGVOL') }</td>
  <td>${ flushing.bagVolumeFormatted } ${ !flushing.bagVolumeUnit ? '' : translate.instant(flushing.bagVolumeUnit)}</td>
</tr>
<tr>
  <td>${translate.instant('O2ACCEPTED')}</td>
  <td>${ flushing.o2accepted } %</td>
</tr>
<tr>
  <td>${translate.instant('EQUIPMENTCAPACITY')}</td>
  <td>${ flushing.eqCapacityFormatted } ${ !flushing.eqCapacityUnit ? '' : translate.instant(flushing.eqCapacityUnit)}</td>
</tr>
<tr>
  <td>${translate.instant('EFFECTIVEWOK')}</td>
  <td>${ flushing.workingHoursFormatted } ${ !flushing.workingHoursUnit ? '' : translate.instant(flushing.workingHoursUnit)}</td>
</tr>
<tr>
  <td>${translate.instant('WORKINGDAYS')}</td>
  <td>${ flushing.workingDaysFormatted } ${ !flushing.workingDaysUnit ? '' : translate.instant(flushing.workingDaysUnit)}</td>
</tr>
<tr>
  <td>${translate.instant('WOKINGMONTH')}</td>
  <td>${ flushing.workingMonthsFormatted } ${ !flushing.workingMonthsUnit ? '' : translate.instant(flushing.workingMonthsUnit)}</td>
</tr>
</tbody>`;

          }
          if (calculation instanceof VacuumCalculation)
          {
            let flushing = <VacuumCalculation> calculation;
            body +=
`<span>${ translate.instant('DATE') } : ${ date }</span>
<table style="width: 100%;background-color: #f3f3f3;">
<thead>
  <tr>
    <th colspan="2" style="background-color: #1c4587;color: white;padding: 10px 0;">
      ${ flushing.name }
    </th>
  </tr>
</thead>
<thead>
  <tr>
    <th colspan="2" style="background-color: #3c78d8;color: white;padding: 5px 0;">
      ${ translate.instant('CALC_PARAMETERS') }
    </th>
  </tr>
</thead>
<tbody>
<tr>
  <td>${translate.instant('VACCUM')}</td>
  <td>${ flushing.vacuumChamberFormatted } ${ !flushing.vacuumChamberUnit ? '' : translate.instant(flushing.vacuumChamberUnit)}</td>
</tr>
<tr>
  <td>${translate.instant('NOPACKPERCYCLE')}</td>
  <td>${ flushing.packagePerCycleFormatted } ${ !flushing.packagePerCycleUnit ? '' : translate.instant(flushing.packagePerCycleUnit)}</td>
</tr>
<tr>
  <td>${translate.instant('EQUIPMENTCAPACITY')}</td>
  <td>${ flushing.eqCapacityFormatted } ${ !flushing.eqCapacityUnit ? '' : translate.instant(flushing.eqCapacityUnit)}</td>
</tr>
<tr>
  <td>${translate.instant('EFFECTIVEWOK')}</td>
  <td>${ flushing.workingHoursFormatted } ${ !flushing.workingHoursUnit ? '' : translate.instant(flushing.workingHoursUnit)}</td>
</tr>
<tr>
  <td>${translate.instant('WORKINGDAYS')}</td>
  <td>${ flushing.workingDaysFormatted } ${ !flushing.workingDaysUnit ? '' : translate.instant(flushing.workingDaysUnit)}</td>
</tr>
<tr>
  <td>${translate.instant('WOKINGMONTH')}</td>
  <td>${ flushing.workingMonthsFormatted } ${ !flushing.workingMonthsUnit ? '' : translate.instant(flushing.workingMonthsUnit)}</td>
</tr>
</tbody>`;
          }
          body +=
`<thead>
  <tr>
    <th colspan="2" style="background-color: #3c78d8;color: white;padding: 10px 0;">
      ${ translate.instant('CALC_RESULTS') }
    </th>
  </tr>
</thead>
  <tbody>
    <tr>
      <td>${translate.instant('GASCONSUMPTION')}</td>
      <td>${ calculation.consumptionPerPackageFormatted } ${ !calculation.consumptionPerPackageUnit ? '' : translate.instant(calculation.consumptionPerPackageUnit)}</td>
    </tr>
    <tr>
      <td>${translate.instant('FLOWRATEROUNDUP')}</td>
      <td>${ calculation.instantaneousFlowRateFormatted } ${ !calculation.instantaneousFlowRateUnit ? '' : translate.instant(calculation.instantaneousFlowRateUnit)}</td>
    </tr>
    <tr>
      <td>${translate.instant('MONTHLYCONS')}</td>
      <td>${ calculation.monthlyConsumptionFormatted } ${ !calculation.monthlyConsumptionUnit ? '' : translate.instant(calculation.monthlyConsumptionUnit)}</td>
    </tr>
    <tr>
      <td>${translate.instant('YEARLYCONS')}</td>
      <td>${ calculation.yearlyConsumptionFormatted } ${ !calculation.yearlyConsumptionUnit ? '' : translate.instant(calculation.yearlyConsumptionUnit)}</td>
    </tr>
  </tbody>
</table><br />`;
        }
      }
    }
    return body;
  }
}

export class CartItem
{
  public item      : Cartable;
  public group     : string;
  public timestamp : number;

  constructor(obj : any = null)
  {
    console.log(obj);

    if (obj == null)
      return;

    this.group     = obj.group;
    this.timestamp = obj.timestamp;

    if (obj.item.ProductId)     this.item = new Product(obj.item);
    if (obj.item.vacuumChamber) this.item = new VacuumCalculation(obj.item);
    if (obj.item.bagVolume)     this.item = new FlushingCalculation(obj.item);
  }
}

export interface Cartable
{
  getBusinessCode() : string;
}



// WEBPACK FOOTER //
// ./src/app/shared/providers/cart.provider.ts